import React, { useEffect, useState, useRef } from "react";
import * as projectAction from "../../../redux/actions/projectAction";
import { useDispatch, useSelector } from "react-redux";
import {
  API_STATUS,
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
} from "../../../constant/constant";
import {
  ACCESS_DENIED,
  ADMIN_ADD_PROJECT,
  ADMIN_PROJECT,
} from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import ProjectList from "../component/project/projectList";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";
import { InactiveClient, roleAccess } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";

export default function ProjectListContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);
  const projectsListData = useSelector((state) => state.projectList);
  const projectListDelete = useSelector((state) => state.deleteProject.status);
  useEffect(() => {
    if (projectListDelete === "SUCCESS" && deleteTriggeredRef.current) {
      deleteTriggeredRef.current = false;
      const currentFilter = projectsListData?.filterObj || defaultData;
      getProjectListData(currentFilter);
    }
  }, [projectListDelete]);

  const getProjectListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(projectAction.getProjectList(data));
    dispatch(projectAction.getProjectsFilterObj(data));
  };

  const isLoading = useSelector(
    (state) => state.deleteProject.isLoading || state.projectList.isLoading,
  );
  const clientDivision = useSelector((state) => state.getDropdownDataKeyValue);

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const divisions = userInfo?.divisions?.filter(
    (i) => i?.serviceType == PRODUCT_ID(),
  );
  const isClient = userInfo?.isClient;
  const { HbnClientSystemRole } = roleAccess();
  const hbnextRole =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const showAllDivisions = HbnClientSystemRole || hbnextRole;

  const divisionsWithAll = showAllDivisions
    ? [{ key: "AllDivision", value: "All Divisions" }, ...(divisions ?? [])]
    : divisions;

  const [clientDivisions, setClientDivisions] = useState();
  const valueCheck = clientDivisions || divisions;
  const clientSwitch = isClient || ORG_ID() !== LOGIN_ORG_ID();
  useEffect(() => {
    if (clientSwitch || showAllDivisions) {
      if (clientDivision?.status === API_STATUS.SUCCESS) {
        const divisions = clientDivision?.data?.divisons && [
          ...clientDivision?.data?.divisons,
        ];
        divisions?.unshift({ key: "AllDivision", value: "All Divisions" });
        setClientDivisions(divisions);
      }
    }
  }, [clientDivision, clientSwitch, showAllDivisions]);

  const defaultData = {
    organisationId: ORG_ID(),
    divisionId:
      (clientSwitch && valueCheck) || showAllDivisions ? 0 : divisions[0]?.key,
    search: "",
    page: 1,
    pageSize: PAGE_SIZE,
    userId: 0,
    isSendMail: false,
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADMIN_ADD_PROJECT];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("projectListPreserveState") === "true";
    sessionStorage.removeItem("projectListPreserveState");

    dispatch(projectAction.clearProject());
    if (isFromPreserveRoute && projectsListData?.filterObj) {
      setShouldRestoreState(true);
      getProjectListData(projectsListData.filterObj);
    } else {
      setShouldRestoreState(false);
      getProjectListData(defaultData);
    }
  }, []);

  const addProject = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_ADD_PROJECT);
  };
  function deleteProject(data) {
    if (InactiveClient()) return;
    deleteTriggeredRef.current = true;
    dispatch(projectAction.deleteProject(data));
  }

  useEffect(() => {
    const getDropdownDataKeyValueData = {
      orgId: ORG_ID(),
      flags: "6",
      productId: PRODUCT_ID(),
    };
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  useEffect(() => {
    if (projectsListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Projects has been sent to registered email ID");
    }
  }, [projectsListData]);

  return (
    <>
      {checkPrivileges([12, 70, 71, 72]) ? (
        <>
          <ToastContainer />
          <ProjectList
            projectsListData={isLoading ? [] : projectsListData?.data}
            getProjectListData={getProjectListData}
            addProject={addProject}
            isLoading={isLoading}
            deleteProject={deleteProject}
            isProjectsLoading={isLoading}
            divisionDropdown={
              (clientSwitch || showAllDivisions) && valueCheck
                ? clientDivisions
                : divisionsWithAll
            }
            checkbox={false}
            onRowClick={false}
            onSelectionModelChange={false}
            selectionModel={false}
            isShowDowdownloadButton={true}
            projectsListDatas={projectsListData}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
